/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd39418f06ac79d04c70cf71b29dc084>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "SpeedometerRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: video is set to a faster playback speed
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const SpeedometerRightIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 9a6.5 6.5 0 0 1 10.601-5.043l1.372-.792a8 8 0 0 0-10.99 11.628l1.034-1.086A6.48 6.48 0 0 1 1.5 9"/><path fill="currentcolor" fill-rule="evenodd" d="M9.691 7.658a2.501 2.501 0 1 0 .75 1.299l5.004-2.89a8 8 0 0 0-.68-1.339zm-2.19.976a1 1 0 1 1 1 1.732 1 1 0 0 1-1-1.732" clip-rule="evenodd"/><path fill="currentcolor" d="m15.949 8.086-1.45.837L14.5 9a6.48 6.48 0 0 1-2.017 4.707l1.034 1.086a7.98 7.98 0 0 0 2.432-6.707"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
SpeedometerRightIcon.displayName = 'SpeedometerRightIcon';
var _default = exports.default = SpeedometerRightIcon;